<template>
  <div class="animated fadeIn" style="position:relative">
    <div ref="cnt">
      <b-row>
        <b-col cols="12" md="6">
          <b-card :header="$t('User Details')" style="position:relative">
            <b-form @submit.prevent="onSubmitDetails" autocomplete="off" size="sm" ref="det">
              <FloatingLabel
                v-model="details.username"
                label="Username"
                autocomplete="false"
                :state="isUNValid"
                size="sm"
                aria-describedby="input-live-feedback"
                :debounce="true"
                :readonly="eid != ''"
              >
                <template v-slot:feedback>
                  <div
                    id="input-live-feedback"
                    class="invalid-feedback"
                  >{{$t('Username already taken')}}</div>
                </template>
              </FloatingLabel>
              <FloatingLabel
                v-model="details.password"
                label="Password"
                autocomplete="false"
                type="password"
                size="sm"
              />
              <FloatingLabel v-model="details.name" label="Name" size="sm" />
              <FloatingLabel v-model="details.surname" label="Surname" size="sm" />
              <FloatingLabel
                v-model="details.cnp"
                label="CNP"
                :state="isCNPValid"
                size="sm"
                aria-describedby="input-live-feedback2"
              >
                <template v-slot:feedback>
                  <div id="input-live-feedback2" class="invalid-feedback">{{$t('Invalid CNP')}}</div>
                </template>
              </FloatingLabel>
              <FloatingLabel v-model="details.email_address" label="Email" type="email" size="sm" />
              <FloatingLabel
                v-model="details.phone_number"
                label="Phone Number"
                size="sm"
                class="mb-2"
              />

              <b-form-group :label="$t('Is Active')" class="grouping py-2 px-3 mb-3 mt-0">
                <b-form-checkbox
                  v-model="details.isActive"
                  :value="true"
                  :unchecked-value="false"
                >{{$t('Disable user')}}</b-form-checkbox>
              </b-form-group>
              <div style="text-align:right">
                <b-button
                  type="submit"
                  variant="success"
                  :disabled="!isUNValid || !isCNPValid"
                >{{$t('Save')}}</b-button>
              </div>
            </b-form>
          </b-card>
        </b-col>
        <b-col cols="12" md="6" v-if=" eid != '0' && eid ">
          <b-card :header="$t('User Security')" style="position:relative">
            <b-form @submit.prevent="onSubmitSecurity" ref="sec">
              <b-form-group :label="$t('Allowed IP ranges')" class="grouping p-3 mb-3 mt-0">
                <ListEditor
                  :items="security.allowed_ips"
                  :addLabel="$t('Add new IP / IP range')"
                  :deleteTootltip="$t('Delete')"
                  size="sm"
                />
              </b-form-group>
              <b-form-group :label="$t('Two Factor Authentication')" class="grouping p-3 mb-3 mt-0">
                <b-form-checkbox
                  v-model="security.enabled_2fa"
                  :value="true"
                  :unchecked-value="false"
                >{{$t('Enable two factor authentication')}}</b-form-checkbox>
                <b-form-checkbox
                  v-model="security.force_2fa"
                  :value="true"
                  :unchecked-value="false"
                >{{$t('Force two factor authentication')}}</b-form-checkbox>
                <b-form-checkbox
                  v-model="security.configured_2fa"
                  :value="true"
                  :unchecked-value="false"
                >{{$t('Configured two factor authentication')}}</b-form-checkbox>
              </b-form-group>

              <FloatingLabel
                v-model="security.ga_secret"
                label="Google Authenticator Secret"
                size="sm"
              />

              <b-form-group :label="$t('Working Hours')" class="grouping p-3 mb-3 mt-0">
                <DayTimeListEditor
                  :items="security.working_hours"
                  :addLabel="$t('Add new working hours set')"
                  :deleteTootltip="$t('Delete')"
                  size="sm"
                />
              </b-form-group>
              <div style="text-align:right">
                <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
              </div>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" xl="12" v-if=" eid != '0' && eid ">
          <b-card :header="$t('User Access')" style="position:relative">
            <b-form @submit.prevent="onSubmitPermissions" ref="per">
              <b-form-group
                :label="$t('Enable access to all tenants')"
                class="grouping py-2 px-3 mb-3 mt-0"
                v-if="access.allow_all_tenants"
              >
                <b-form-checkbox
                  v-model="access.all_tenants"
                  :value="true"
                  :unchecked-value="false"
                >{{$t('Enable access')}}</b-form-checkbox>
              </b-form-group>

              <div class="mb-2 position-relative">
                <div
                  class="multiselect-lbl"
                  v-if="access.tenant_ids && access.tenant_ids.length"
                >{{$t('Tenants')}}</div>
                <multiselect
                  v-model="access.tenant_ids"
                  :options="tenantsList"
                  :multiple="true"
                  placeholder="Select tenants"
                  :translate="false"
                  track-by="eid"
                  label="brand_name"
                ></multiselect>
              </div>

              <div class="mb-2 position-relative">
                <div
                  class="multiselect-lbl"
                  v-if="access.shop_group_ids && access.shop_group_ids.length"
                >{{$t('Shop Groups')}}</div>
                <multiselect
                  v-model="access.shop_group_ids"
                  :translate="false"
                  :options="shopGroupsList"
                  :multiple="true"
                  placeholder="Select shop groups"
                  track-by="eid"
                  label="name"
                ></multiselect>
              </div>

              <div class="mb-2 position-relative">
                <div
                  class="multiselect-lbl"
                  v-if="access.shop_ids && access.shop_ids.length"
                >{{$t('Shops')}}</div>
                <multiselect
                  v-model="access.shop_ids"
                  :options="shopsList"
                  :multiple="true"
                  placeholder="Select shops"
                  :translate="false"
                  track-by="eid"
                  label="name"
                ></multiselect>
              </div>

              <div class="mb-2 position-relative">
                <div
                  class="multiselect-lbl"
                  v-if="access.discrete_permissions && access.discrete_permissions.length"
                >{{$t('Permissions')}}</div>
                <multiselect
                  v-model="access.discrete_permissions"
                  :options="permissionsList"
                  :multiple="true"
                  :close-on-select="false"
                  :hide-selected="true"
                  placeholder="Select permission"
                  :translate="false"
                  track-by="name"
                  label="name"
                ></multiselect>
              </div>
              <div class="mb-2 position-relative">
                <div
                  class="multiselect-lbl"
                  v-if="access.permission_role_ids && access.permission_role_ids.length"
                >{{$t('Roles')}}</div>
                <multiselect
                  v-model="access.permission_role_ids"
                  :options="rolesList"
                  :multiple="true"
                  placeholder="Select role"
                  :translate="false"
                  track-by="eid"
                  label="name"
                ></multiselect>
              </div>

              <div style="text-align:right">
                <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
              </div>
            </b-form>
          </b-card>
        </b-col>
      </b-row>

      <!--
      <b-row v-if="eid && eid != '0' && currentUserEID && eid === currentUserEID">
        <b-col cols="12">
          <b-card :header="$t('Own user auth tokens')" style="position:relative">
            <OwnTokens
              :euser_id="eid"
            />
          </b-card>
        </b-col>
      </b-row>
      -->

    </div>
  </div>
</template>

<script>
import ListEditor from "@/components/ListEditor";
import DayTimeListEditor from "@/components/DayTimeListEditor";
import Multiselect from "@/components/multiselect-filters";
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";
import debounce from "@/shared/debounce";
import validCNP from "@/shared/cnp";
import OwnTokens from "./component/OwnTokens";

const ALL = "ALL";
const DETAILS = "DETAILS";
const SECURITY = "SECURITY";
const PERMISSIONS = "PERMISSIONS";

export default {
  name: "user",
  props: ["selectedeid"],
  components: {
    ListEditor,
    DayTimeListEditor,
    Multiselect,
    FloatingLabel,
    OwnTokens,
  },
  data: function() {
    return {
      eid: "",
      currentUserEID: "",

      isUNValid: true,
      isCNPValid: true,

      delay: 500,
      details: {
        tvalue: "test",
        username: "",
        name: "",
        surname: "",
        password: "",
        email_address: "",
        cnp: "",
        phone_number: "",
        isActive: false,
        flags: null,
      },
      security: {
        allowed_ips: [],
        enabled_2fa: false,
        force_2fa: false,
        configured_2fa: false,
        ga_secret: "",
        working_hours: []
      },
      access: {
        permission_role_ids: null,
        discrete_permissions: null,
        tenant_ids: null,
        shop_group_ids: null,
        shop_ids: null,
        allow_all_tenants: false,
        all_tenants: false
      },

      errShow: "",
      errMsg: "",

      newId: false,
      temp: {}
    };
  },
  watch: {
    "details.username": function(nv, ov) {
      if (nv == "") {
        this.isUNValid = null;
        return;
      }
      if (nv != ov) {
        this.checkUser();
      }
    },
    "details.cnp": function(newVal) {
      this.isCNPValid = false;
      if (validCNP(newVal)) {
        this.isCNPValid = true;
      }
    }
  },
  computed: {
    permissionsList() {
      return this.$store.getters["cache/permissions"];
    },
    rolesList() {
      return this.$store.getters["cache/roles"];
    },
    tenantsList() {
      return this.$store.getters["cache/tenants"];
    },
    shopsList() {
      const self = this;
      const list = this.$store.getters["cache/shops"];

      const tmp = [];
      if (this.access.tenant_ids && this.access.tenant_ids.length) {
        list.forEach(item => {
          self.access.tenant_ids.forEach(tenant => {
            if (item.etenant_id == tenant.eid) {
              const data = JSON.parse(JSON.stringify(item));
              data.name = tenant.brand_name + " - " + item.name;
              tmp.push(data);
            }
          });
        });

        self.access.tenant_ids.forEach(tenant => {
          const data = {
            eid: tenant.all_shops_id,
            name: tenant.brand_name + " - All Shops"
          };
          tmp.unshift(data);
        });
      }

      return tmp;
    },
    shopGroupsList() {
      const self = this;
      const list = this.$store.getters["cache/shopGroups"];

      const tmp = [];
      if (this.access.tenant_ids && this.access.tenant_ids.length) {
        list.forEach(item => {
          self.access.tenant_ids.forEach(tenant => {
            if (item.etenant_id == tenant.eid) {
              const data = JSON.parse(JSON.stringify(item));
              data.name = tenant.brand_name + " - " + item.name;
              tmp.push(data);
            }
          });
        });
      }
      return tmp;
    }
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    const loader = this.$loading.open({
      container: this.$refs.cnt
    });

    Promise.all([
      this.$store.dispatch("cache/fetch", "permissions").catch(e => e),
      this.$store.dispatch("cache/fetch", "roles").catch(e => e),
      this.$store.dispatch("cache/fetch", "tenants").catch(e => e),
      this.$store.dispatch("cache/fetch", "shops").catch(e => e),
      this.$store.dispatch("cache/fetch", "shopGroups").catch(e => e),
      this.$store.dispatch("auth/me").then(resp => this.currentUserEID = resp.data.eid).catch(e => e),
    ]).finally(() => {
      loader.close();

      if (this.eid != "0" && this.eid != "") {
        this.loadData();
      } else {
        this.newId = true;
      }
    });
  },
  methods: {
    checkUser() {
      if (this.eid == "") {
        this.$store
          .dispatch("user/check", { username: this.details.username })
          .then(resp => {
            if (resp.data && resp.data.available) {
              this.isUNValid = true;
            } else {
              this.isUNValid = false;
            }
          })
          .catch(() => {});
      }
    },
    loadData() {
      if (this.eid == "") {
        // new user; nothing to load
        return;
      }
      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      this.$store
        .dispatch("user/read", this.eid)
        .then(resp => {
          this.temp = resp.data;
          this.populateData(resp.data, ALL);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    onSubmitDetails() {
      const loadDet = this.$loading.open({
        container: this.$refs.det
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "user/update";
      if (this.newId) {
        apiAction = "user/create";
      } else {
        detailsData.eid = this.eid;
      }

      if (detailsData.isActive) {
        detailsData.flags |= 1 << 0;
      } else {
        detailsData.flags &= ~(1 << 0);
      }
      delete detailsData.isActive;

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "User updated";
          if (this.newId && resp.data.id) {
            this.updateNewId(resp.data.id);
            msg = "User created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    onSubmitSecurity() {
      const loadSec = this.$loading.open({
        container: this.$refs.sec
      });

      const securityData = JSON.parse(JSON.stringify(this.security));
      let apiAction = "user/update";
      if (this.newId) {
        apiAction = "user/create";
      } else {
        securityData.eid = this.eid;
      }

      let tmp = [];
      for (let i = 0; i < securityData.working_hours.length; i++) {
        tmp.push(securityData.working_hours[i][0]);
        tmp.push(this.hoursToMinutes(securityData.working_hours[i][1]));
        tmp.push(this.hoursToMinutes(securityData.working_hours[i][2]));
      }
      if (tmp.length == 0) tmp = [];
      securityData.working_hours = tmp;

      this.$store
        .dispatch(apiAction, securityData)
        .then(resp => {
          let msg = "User updated";
          if (this.newId && resp.data.id) {
            this.updateNewId(resp.data.id);
            msg = "User created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadSec.close();
        });
    },
    onSubmitPermissions() {
      const loadPer = this.$loading.open({
        container: this.$refs.per
      });

      const accessData = JSON.parse(JSON.stringify(this.access));
      delete accessData.allow_all_teants;
      let apiAction = "user/update";
      if (this.newId) {
        apiAction = "user/create";
      } else {
        accessData.eid = this.eid;
      }

      if (
        accessData.discrete_permissions &&
        accessData.discrete_permissions.length
      ) {
        let tmpPermissions = [];
        for (let i = 0; i < accessData.discrete_permissions.length; i++) {
          tmpPermissions.push(accessData.discrete_permissions[i].name);
        }
        if (tmpPermissions.length == 0) tmpPermissions = [];
        accessData.discrete_permissions = tmpPermissions;
      } else {
        accessData.discrete_permissions = [];
      }

      const keys = [
        "permission_role_ids",
        "tenant_ids",
        "shop_group_ids",
        "shop_ids"
      ];

      keys.forEach(key => {
        let tmp = [];
        if (accessData[key] && accessData[key].length) {
          for (let i = 0; i < accessData[key].length; i++) {
            tmp.push(accessData[key][i].eid);
          }
          if (tmp.length == 0) tmp = [];
          accessData[`e${key}`] = tmp;
        } else {
          accessData[`e${key}`] = [];
        }
        if (accessData[key]) delete accessData[key];
      });

      this.$store
        .dispatch(apiAction, accessData)
        .then(resp => {
          let msg = "User updated";
          if (this.newId && resp.data.id) {
            this.updateNewId(resp.data.id);
            msg = "User created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadPer.close();
        });
    },
    populateData(u, flag) {
      if (typeof u == "undefined") return;
      this.eid = typeof u.eid != "undefined" ? u.eid : "";

      if (flag == ALL || flag == DETAILS) {
        this.details.username = u.username;
        this.details.name = u.name;
        this.details.surname = u.surname;
        this.details.password = u.password;
        this.details.email_address = u.email_address;
        this.details.phone_number = u.phone_number;
        this.details.cnp = u.cnp;
        this.details.isActive = (u.flags >> 0) % 2 != 0;
        this.details.flags = u.flags;
      }

      if (flag == ALL || flag == SECURITY) {
        this.security.allowed_ips = u.allowed_ips ? u.allowed_ips : [];
        this.security.enabled_2fa = u.enabled_2fa;
        this.security.force_2fa = u.force_2fa;
        this.security.configured_2fa = u.configured_2fa;
        this.security.ga_secret = u.ga_secret;

        const working_hours = [];
        if (u.working_hours) {
          for (let i = 0; i < u.working_hours.length; i += 3) {
            working_hours.push([
              u.working_hours[i],
              this.minutesToHours(u.working_hours[i + 1]),
              this.minutesToHours(u.working_hours[i + 2])
            ]);
          }
        }
        this.security.working_hours = working_hours;
      }
      if (flag == ALL || flag == PERMISSIONS) {
        this.access.allow_all_tenants =
          typeof u.allow_all_tenants != "undefined"
            ? u.allow_all_tenants
            : false;

        this.access.all_tenants =
          typeof u.all_tenants != "undefined" ? u.all_tenants : false;

        this.access.discrete_permissions = u.discrete_permissions
          ? u.discrete_permissions
          : [];

        let tmpPermissions = [];
        if (this.access.discrete_permissions.length > 0) {
          this.permissionsList.forEach(element => {
            for (let i = 0; i < this.access.discrete_permissions.length; i++) {
              if (element.name == this.access.discrete_permissions[i]) {
                tmpPermissions.push(element);
              }
            }
          });
        }
        this.access.discrete_permissions = tmpPermissions;

        const keys = [
          "permission_role_ids",
          "tenant_ids",
          "shop_group_ids",
          "shop_ids"
        ];

        keys.forEach(key => {
          this.access[key] = u[`e${key}`] ? u[`e${key}`] : [];

          const tmp = [];
          if (this.access[key].length > 0) {
            let list = [];

            switch (key) {
              case "permission_role_ids":
                list = this.rolesList;
                break;
              case "tenant_ids":
                list = this.tenantsList;
                break;
              case "shop_group_ids":
                list = this.shopGroupsList;
                break;
              case "shop_ids":
                list = this.shopsList;
                break;
              default:
                list = [];
            }

            list.forEach(element => {
              for (let i = 0; i < this.access[key].length; i++) {
                if (element.eid == this.access[key][i]) {
                  tmp.push(element);
                }
              }
            });
          }
          this.access[key] = tmp;
        });
      }
    },
    minutesToHours(total) {
      const minutes = total % 60;
      const hours = (total - minutes) / 60;
      return (
        (hours < 10 ? `0${hours}` : hours) +
        ":" +
        (minutes < 10 ? `0${minutes}` : minutes)
      );
    },
    hoursToMinutes(total) {
      if (!total) return 0;
      const parts = total.split(":", 2);
      const hours = parseInt(parts[0]) * 60;
      const minutes = parseInt(parts[1]);
      return hours + minutes;
    },
    updateNewId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "User", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


